import YouTubeVideoEmbed, { YOUTUBE_VIDEO_EMBED_ID, pauseYouTubeVideoEmbed, playYouTubeVideoEmbed } from "./YouTubeVideoEmbed";

export { YOUTUBE_VIDEO_EMBED_ID, pauseYouTubeVideoEmbed, playYouTubeVideoEmbed };
export default YouTubeVideoEmbed;
